module.exports = __webpack_public_path__ + "img/3_diamond.16dda4ab.jpg";